import { useCallback } from "react";
import { ServerMessages, useSocketContext } from "../context/SocketContext";
import { DashboardData } from "../types/Dashboard";

const useDashboardService = () => {
    const { emit } = useSocketContext();

    const fetchDashboardData = useCallback(async (): Promise<DashboardData> => {
        const response = await emit({
            message: ServerMessages.getGeneralStatus,
        });

        return response?.data;
    }, [emit]);

    return {
        fetchDashboardData,
    };
};

export default useDashboardService;